import { WebAPIChartSlicerData } from '../../globals/webApiTypes/elements/WebAPICBS';
import { rijksFont } from '@/uiPrimitives/font/fontFace';
import { VictoryLabelStyleObject } from 'victory';

export const fontStyle = {
	...rijksFont.style,
	fontSize: 16.5,
} as const satisfies VictoryLabelStyleObject;

export const axisFontStyle = {
	...rijksFont.style,
	fontSize: 19.8,
};

export const cbsColors = {
	blue: `hsl(200, 99%, 31%)`, // currently not possible to import from *.css.tsx files in unit-tests
	violet: '#a90061',
	purple: '#42145f',
	green: '#727800',
} as const;

export const toolTipProps = {
	dy: 0,
	cornerRadius: 1,
	pointerLength: 12,
	pointerWidth: 12,
	flyoutPadding: {
		left: 20,
		right: 20,
		top: 30,
		bottom: 15,
	},
};

export const chartPadding = { inline: 15, block: 55 };
export const yAxisLabelBlockSize = 40; // The label on the y-axis is vertical, so we need the block size to calculate with width

export const periodQueryKeyMap = {
	nl: 'Perioden',
	en: 'Periods',
} as const satisfies Record<
	WebAPIChartSlicerData['dataSourceLanguage'],
	string
>;

export const cbsApiBaseUrl = 'https://opendata.cbs.nl/';
